import ButtonClose from '../Button/IconButton'
interface Props {
  title?: string
  isEdit?: boolean
  handleBack?: () => void
}

const HeaderTitle = ({title, isEdit = false, handleBack}: Props) => {
  return (
    <div>
      {isEdit && <ButtonClose onClick={handleBack} color='#283897' />}
      <h4 className='mb-4'>{title}</h4>
    </div>
  )
}

export default HeaderTitle
